
import React from 'react';
import { AdminLayout } from '@/components/admin/AdminLayout';
import { ReviewsContent } from '@/components/admin/reviews/ReviewsContent';

export default function Reviews() {
  return (
    <AdminLayout>
      <ReviewsContent />
    </AdminLayout>
  );
}
